import { z } from "zod";

export const profileUpdateSchema = z.object({
  firstName: z.string().min(1, {
    message: "Please enter first name",
  }),
  lastName: z.string().min(1, {
    message: "Please enter first name",
  }),
  instituteName: z.string().min(1, {
    message: "Please enter institution name",
  }),
});

export type ProfileUpdate = z.infer<typeof profileUpdateSchema>;
